import { render, staticRenderFns } from "./survey-step-covid-19.vue?vue&type=template&id=1309b86e"
import script from "./survey-step-covid-19.vue?vue&type=script&lang=js"
export * from "./survey-step-covid-19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports